"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports["default"] = void 0;

var _createSvgIcon = _interopRequireDefault(require("../createSvgIcon"));

var _Grid = _interopRequireDefault(require("@rsuite/icon-font/lib/layout/Grid"));

// Generated by script, don't edit it please.
var Grid = (0, _createSvgIcon["default"])({
  as: _Grid["default"],
  ariaLabel: 'grid',
  category: 'layout',
  displayName: 'Grid'
});
var _default = Grid;
exports["default"] = _default;
module.exports = exports.default;